import { useQuery } from '@tanstack/react-query';
import { projectsApi } from '@/lib/api';
import type { ProjectMember } from '@/types';

export function useProjectMembers(projectId: string | undefined) {
  return useQuery({
    queryKey: ['projects', projectId, 'members'],
    queryFn: async () => {
      if (!projectId) throw new Error('Project ID required');
      const response = await projectsApi.getMembers(projectId);
      return response.data as ProjectMember[];
    },
    enabled: !!projectId,
  });
}
